module.exports = __webpack_public_path__ + "media/HC3P_Showreel.c2aef6d7.mp4";